import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from "contentful";

/**
 * Fields type definition for content type 'TypeSeoData'
 * @name TypeSeoDataFields
 * @type {TypeSeoDataFields}
 * @memberof TypeSeoData
 */
export interface TypeSeoDataFields {
    /**
     * Field type definition for field 'seoTitle' (SEO Title)
     * @name SEO Title
     * @localized false
     */
    seoTitle: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'seoDescription' (SEO Description)
     * @name SEO Description
     * @localized false
     */
    seoDescription: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'seoImage' (SEO Image)
     * @name SEO Image
     * @localized false
     */
    seoImage?: EntryFieldTypes.AssetLink;
    /**
     * Field type definition for field 'noIndex' (No Index)
     * @name No Index
     * @localized false
     */
    noIndex: EntryFieldTypes.Boolean;
}

/**
 * Entry skeleton type definition for content type 'seoData' (SEO Data)
 * @name TypeSeoDataSkeleton
 * @type {TypeSeoDataSkeleton}
 * @author 7BjsgI9gzpO6Dv7BH5AOT6
 * @since 2018-03-28T18:42:20.614Z
 * @version 17
 */
export type TypeSeoDataSkeleton = EntrySkeletonType<TypeSeoDataFields, "seoData">;
/**
 * Entry type definition for content type 'seoData' (SEO Data)
 * @name TypeSeoData
 * @type {TypeSeoData}
 * @author 7BjsgI9gzpO6Dv7BH5AOT6
 * @since 2018-03-28T18:42:20.614Z
 * @version 17
 */
export type TypeSeoData<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<TypeSeoDataSkeleton, Modifiers, Locales>;

export function isTypeSeoData<Modifiers extends ChainModifiers, Locales extends LocaleCode>(entry: Entry<EntrySkeletonType, Modifiers, Locales>): entry is TypeSeoData<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'seoData'
}
